<template>
    <div class="">
        <DataTable v-if="DataTable_render" :columns="columns" :data="MusteriGecmisIslemListesi"
            v-on:set-child-data="getDataChild" :editbutton="false" />

    </div>
</template>

<script>
import DataTable from "../../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";


export default {
    props: {
        pMusteri: { default: "0", type: String }
    },
    data() {
        return {
            DataTable_render: false,
            MusteriGecmisIslemListesi: [],
            columns: [
                { field: "UrunAd", header: "Urun Adı" },
                { field: "Miktar", header: "Miktar" },
                { field: "Tutar", header: "Tutar" },
                { field: "IslemTarihSaat", header: "İşlem Tarih" },
            ],
        };
    },
    methods: {
        InitServis() {
            let data = {
                Musteri_rowid: this.pMusteri
            };
            GlobalServis.GlobalServis("POST", "GetMusteriGecmisIslemler", data).then((res) => {
                if (res.status == 200) {
                    this.MusteriGecmisIslemListesi = res.data;
                    this.DataTable_render = true;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
    },
    mounted() {
        this.InitServis();
    },
    components: {
        DataTable,
    },

};
</script>